<script>
export default ({

    async created() {

        console.log("Created")

        if (this.$store.state.auth.isSuperAdmin) {

            await this.getXSurflogOrganisations().then((val) => {
                if (val) {

                    if (this.$store.state.auth.redirectLink != null) {
                        this.$router.push({ path: this.$store.state.auth.redirectLink })
                        this.$store.commit("auth/setRedirectLink", null)
                    } else {
                        this.$router.push({ name: 'dashboard' })
                    }
                }
            })
        } else {
            // console.log(this.$store.state.auth.organisation_name)

            if (this.$store.state.auth.redirectLink != null) {
                this.$router.push({ path: this.$store.state.auth.redirectLink })
                this.$store.commit("auth/setRedirectLink", null)
            } else {
                this.$router.push({ name: 'dashboard' })
            }
        }
    },

    methods: {

        async getXSurflogOrganisations() {
            await this.$axios.get("/admin-common/get-xsurflog-organisations")
                .then((response) => {
                    if (response.data.organisations.length > 0) {
                        this.$store.commit("auth/setOrganisations", response.data.organisations)
                        if (this.$store.state.auth.organisation == null || this.$store.state.auth.organisation == undefined) {
                            if (this.$store.state.auth.organisations.length > 0) {
                                this.$store.commit("auth/setOrganisation", response.data.organisations[0])
                                this.CheckAccount(this.$store.state.auth.organisation.orguuid, this.$store.state.auth.organisation.name)
                            }
                        }
                        //console.log(this.$store.state.auth.organisation)
                    }
                    if (this.$store.state.auth.redirectLink != null) {
                        this.$router.push({ path: this.$store.state.auth.redirectLink })
                        this.$store.commit("auth/setRedirectLink", null)
                    } else {
                        this.$router.push({ name: 'dashboard' })
                    }
                    return true
                })
                .catch((error) => {
                    console.log(error)
                    return false
                    //this.$toast.error(error.response.data.message)
                })
        },

        async CheckAccount(OrgUuid, Name) {
            try {

                const payLoad = {
                    org_uuid: OrgUuid,
                    name: Name
                }

                fetch(process.env.VUE_APP_API_BASE_URL + "/api/main/v1/auth/non-login/check-account-exist", {
                    method: "POST",
                    body: JSON.stringify(payLoad),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                });

                // console.log(OrgUuid)
                // console.log(Name)

                // const resp = await app.$axios.post("non-login/check-account-exist", payLoad)
                // if(resp.data.success != null && resp.data.success == false ) {
                // 	this.$toast.error(resp.data.message)
                // } else {
                // 	this.$toast.success(resp.data.message)
                // 	this.getAllowList()
                // }
            } catch (error) {
                console.log(error)
                //app.$toast.error(error.response.data.message)
            }
        }

    },

})
</script>